<template>
    <div>
    <modal
        name="edit-room"
        width="80%"
        height="auto"
        overlayTransition="fade"
        :adaptive="true"
        @before-close="beforeClose"
    >
        <div class="wrapper edit-room">
            <div class="section">
                <h1>{{ newRoomData.name || "New Room" }}</h1>
            </div>
            <div class="section">
                <UploadImage
                    text="Room Logo"
                    border-radius="0"
                    :storageRef="storageRef"
                    :img="roomData.img"
                    @updateImg="updateImg"
                />
            </div>
            <div class="section">
                <br>
                <span>Room Name</span>
                <input
                    class="text-input"
                    v-model="newRoomData.name"
                    placeholder="What is the name of your room?"
                    v-on:keyup.enter="submit"
                >
                <span>Preview Link</span>
                <input
                    class="text-input"
                    v-model="newRoomData.iframe"
                    placeholder="Embed link to video preview"
                    v-on:keyup.enter="submit"
                >
            </div>
            <SubmitButton
                @click="submit"
                text="Submit"
            />
            <SubmitButton
                @click="$modal.hide('edit-room')"
                text="Cancel"
            />
        </div>
    </modal>
    </div>
</template>

<script>
import UploadImage from '../tools/UploadImage'

import { storage, firestore } from '../../db'
const expos = firestore.collection('expos')

export default {
    name: 'EditRoom',
    props: ['expoId', 'roomId', 'roomData'],
    components: {
        UploadImage
    },
    data() {
        return {
            newRoomData: {
                name: '',
                iframe: '',
                img: '',
            },
        }
    },
    computed: {
        storageRef() {
            if (this.roomId)
                return storage.ref().child(`expos/${this.expoId}`).child(this.roomId.toString())
            else
                return null
        }
    },
    methods: {
        submit() {
            if (!this.newRoomData.name) {
                this.error('Enter a name for the room!')
                return
            }
            this.editIFrameLink()
            this.loading = true
            let obj = {}
            obj['rooms.' + this.roomId] = this.newRoomData
            expos.doc(this.expoId).update(obj)
                .then(() => {
                    this.notif('Room Info Updated')
                    this.$modal.hide('edit-room')
                }).catch(() => {
                    this.error('Error updating room info!')
                }).finally(() => {
                    this.loading = false
                })
        },
        editIFrameLink() {
            let iframe = this.newRoomData['iframe']
            if (!iframe) {
                return
            }
            else if (iframe.includes('youtube.com/') || iframe.includes('youtu.be/')) {
                this.newRoomData['iframe'] = this.youtubeLinkToEmbed(iframe)
            } else {
                this.warn('Unsupported iframe link. We\'ll try to display it anyway (can\'t promise anything though!)')
            }
        },
        updateImg(value) {
            this.newRoomData.img = value.img
            this.submit()
        },
        refresh() {
            this.newRoomData = { ...this.roomData}
        },
        beforeClose(e) {
            if (!this.roomData || !this.roomData.name) {
                this.warn('Enter a name for the room and press submit!')
                e.cancel()
            }
        }
    },
    watch: {
        roomId: {
            immediate: true,
            handler() { this.refresh() }
        },
        expoId: {
            immediate: true,
            handler() { this.refresh() }
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../interface.scss';

.wrapper.edit-room {
    padding-top: 0;
    overflow-y: scroll;
    max-height: 80vh;
}

</style>